import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close-h",
  "use": "icon-close-h-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close-h\">\n<g id=\"icon-close-h_&#229;&#133;&#179;&#233;&#151;&#173;_h\">\n<g id=\"icon-close-h_Group 3747\">\n<rect id=\"icon-close-h_Rectangle 908\" x=\"5.41406\" y=\"4\" width=\"20\" height=\"2\" transform=\"rotate(45 5.41406 4)\" />\n<rect id=\"icon-close-h_Rectangle 909\" width=\"20\" height=\"2\" transform=\"matrix(-0.707107 0.707107 0.707107 0.707107 18.1421 4)\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol